import { cn } from "utils/presentation";

const ENERGY_CONFIG: Record<
  string,
  { bg: string; text: string; letter: string }
> = {
  Fire: { bg: "bg-red-600", text: "text-white", letter: "R" },
  Water: { bg: "bg-blue-500", text: "text-white", letter: "W" },
  Grass: { bg: "bg-green-600", text: "text-white", letter: "G" },
  Lightning: { bg: "bg-yellow-400", text: "text-yellow-900", letter: "L" },
  Psychic: { bg: "bg-purple-500", text: "text-white", letter: "P" },
  Fighting: { bg: "bg-orange-700", text: "text-white", letter: "F" },
  Darkness: { bg: "bg-gray-800", text: "text-white", letter: "D" },
  Metal: { bg: "bg-gray-400", text: "text-gray-900", letter: "M" },
  Dragon: { bg: "bg-amber-500", text: "text-white", letter: "N" },
  Fairy: { bg: "bg-pink-400", text: "text-white", letter: "Y" },
  Colorless: { bg: "bg-gray-300", text: "text-gray-700", letter: "C" },
};

interface PokemonEnergyIconProps {
  type: string;
  className?: string;
}

export function PokemonEnergyIcon({ type, className }: PokemonEnergyIconProps) {
  const config = ENERGY_CONFIG[type] ?? ENERGY_CONFIG.Colorless;

  return (
    <span
      className={cn(
        "inline-flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-bold leading-none",
        config.bg,
        config.text,
        className
      )}
      title={type}
    >
      {config.letter}
    </span>
  );
}
